/* eslint-disable no-use-before-define */
import React from 'react'
import { $, publish, trapFocus, returnModalFocus } from '../twd'
import Calculator from '../calculator/modal'
import CorporatesMarketNewsModal from '../corporates/market-news/modal'
import Disclosures from './disclosures'
import Alerts from '../header/alerts-modal'
import Holdings from '../header/holdings-modal'
import ManageSavedSearches from '../saved-searches/manage-saved-searches'
import MunicipalsMarketNewsModal from '../municipals/market-news/modal'
import TradeHistory from '../trade-history'
import OfferingsDepthOfMarket from '../offerings/depth-of-market'
import OfferingsModal from '../offerings/modal'
import OrderDetailModal from '../orders/modal'
import PortfolioReportModal from '../portfolio-report/modal'
import SaveSearch from '../saved-searches/save-search'
import TeyCalculator from '../tey-calculator'
import Underwriter from '../bond-detail/underwriter-modal'
import ArsInfo from '../bond-detail/ars-info-modal'
import F2fInfo from '../bond-detail/f2f-info-modal'
import MbsSpeed from '../bond-detail/mbs-speed-modal'
import MultiStepCoupon from '../bond-detail/multi-step-coupon-modal'
import Events from '../bond-detail/events/modal'
import Factors from '../bond-detail/factors-modal'
import OrderTicketSearchModal from '../order-ticket/search-modal'
import OrderTicketDuplicateOrderModal from '../order-ticket/duplicate-order-modal'
import OrderTicketPriceChangeNoticeModal from '../order-ticket/price-change-notice-modal'
import OrderTicketAttestationsModal from '../order-ticket/form/attestations-modal'


const onModalKeydown = function (ev) {
    trapFocus(this, ev)
}

export default ({view, args}) => {
    const ts = (args || {}).ts
    const ref = React.useRef(null)

    React.useEffect(() => {
        $('#modal').modal(view ? 'show' : 'hide')

        if (view) {
            $('#modal').one('hidden.bs.modal', () => {
                publish('hide_flyout')
                returnModalFocus()
            })
        }

        setTimeout(() => {
            const fe = $('#modal .focus-on-load')
            if (fe.length>0) {
                fe.focus()
                return
            }

            const fs = $('#modal :focusable')
            if (fs.eq(0).focus().length===0) {
                $('#modal a.close').eq(0).focus()
            }

        }, 200)
    }, [view, ts])

    React.useEffect(() => {
        const el = ref.current
        if (!el) return

        el.removeEventListener('keydown', onModalKeydown)
        el.addEventListener('keydown', onModalKeydown)
        return () => {
            el.removeEventListener('keydown', onModalKeydown)
        }
    }, [ref])

    let cmp =
        view==='corporates-market-news-modal' ? <CorporatesMarketNewsModal {...args} /> :
        view==='depth-of-market' ? <OfferingsDepthOfMarket {...args} /> :
        view==='disclosures' ? <Disclosures {...args} /> :
        view==='holdings' ? <Holdings {...args} /> :
        view==='alerts' ? <Alerts {...args} /> :
        view==='calculator' ? <Calculator {...args} /> :

        view==='manage-saved-searches' ? <ManageSavedSearches {...args} /> :
        view==='municipals-market-news-modal' ? <MunicipalsMarketNewsModal {...args} /> :
        view==='offerings-modal' ? <OfferingsModal {...args} /> :
        view==='order-detail' ? <OrderDetailModal {...args} /> :
        view==='portfolio-report-modal' ? <PortfolioReportModal {...args} /> :
        view==='save-search' ? <SaveSearch {...args} /> :
        view==='underwriter' ? <Underwriter {...args} /> :
        view==='ars-info' ? <ArsInfo {...args} /> :
        view==='f2f-info' ? <F2fInfo {...args} /> :
        view==='mbs-speed' ? <MbsSpeed {...args} /> :
        view==='multi-step-coupon' ? <MultiStepCoupon {...args} /> :
        view==='events' ? <Events {...args} /> :
        view==='factors' ? <Factors {...args} /> :
        view==='tey-calculator' ? <TeyCalculator {...args} /> :
        view==='trade-history' ? <TradeHistory {...args} /> :
        view==='order-ticket-search-modal' ? <OrderTicketSearchModal {...args} /> :
        view==='order-ticket-duplicate-order-modal' ? <OrderTicketDuplicateOrderModal {...args} /> :
        view==='order-ticket-price-change-notice-modal' ? <OrderTicketPriceChangeNoticeModal {...args} /> :
        view==='order-ticket-attestations-modal' ? <OrderTicketAttestationsModal {...args} /> :
        null

    return <React.Fragment>
        <div ref={ref} className="modal" id="modal" role="dialog" data-backdrop="static">{cmp}</div>
    </React.Fragment>
}


(function($) {
    function visible(element) {
        return $.expr.filters.visible(element) && !$(element).parents().addBack().filter(function() {
            return $.css(this, 'visibility') === 'hidden';
        }).length;
    }

    function focusable(element) {
        var map, mapName, img, nodeName = element.nodeName.toLowerCase()
        var isTabIndexNotNaN = !isNaN($.attr(element, 'tabindex'))
        if ('area' === nodeName) {
            map = element.parentNode;
            mapName = map.name;
            if (!element.href || !mapName || map.nodeName.toLowerCase() !== 'map') {
                return false;
            }
            img = $('img[usemap=#' + mapName + ']')[0];
            return !!img && visible(img);
        }

        if (!visible(element)) return false

        if (/input|select|textarea|button|object/.test(nodeName)) {
            return !element.disabled
        }

        if ('a' === nodeName) {
            return element.href || isTabIndexNotNaN
        }

        return isTabIndexNotNaN
    }

    $.extend($.expr[':'], {
        focusable: function(element) {
            return focusable(element);
        }
    });
})($)



// WEBPACK FOOTER //
// ./src/App/modal.js